if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
      
      window.addEventListener("load", () => {
        function showTab(hash){
          if(hash){
            var target = document.querySelector('#' + hash);
            if(target){
              target.click();
            }
          }
        }
        showTab(window.location.hash.substr(1));
        
        var hash_links = document.querySelectorAll('a[href*="#"]')
        for (i = 0; i < hash_links.length; i++) {
          hash_links[i].addEventListener('click', function() {
            showTab(this.hash.substr(1))
          });
        }
      })
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}
